import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnDestroy, ViewChild } from '@angular/core'
import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common'
import { FormProjetComponent } from '../form-projet/form-projet.component'
import { FormModeValorisationComponent } from '../form-mode-valorisation/form-mode-valorisation.component'
import { FormRaccordementComponent } from '../form-raccordement/form-raccordement.component'
import { OngletEnum } from '../../model/onglet.enum'
import { AbstractControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms'
import { FormCapexGeneralisesComponent } from '../form-capex-generalises/form-capex-generalises.component'
import { FormCapexTypePoseComponent } from '../form-capex-type-pose/form-capex-type-pose.component'
import { FormZone1Component } from '../form-zone1/form-zone1.component'
import { FormZone2Component } from '../form-zone2/form-zone2.component'
import { FormZone3Component } from '../form-zone3/form-zone3.component'
import { FormZone4Component } from '../form-zone4/form-zone4.component'
import { FormZone5Component } from '../form-zone5/form-zone5.component'
import { FormZone6Component } from '../form-zone6/form-zone6.component'
import { ModalGenerationLivrableComponent } from '../modals/modal-generation-livrable/modal-generation-livrable.component'
import { SessionSaveDto } from '../../../sunleon/data-access/http/dto/session-save-dto'
import { SessionZoneSaveDto } from '../../../sunleon/data-access/http/dto/session-zone-save-dto'
import { SessionCommunSaveDto } from '../../../sunleon/data-access/http/dto/session-commun-save-dto'
import { scrollToInvalidElement } from '../../../shared/utils/utils'
import { saveAs } from 'file-saver'
import { RouterLinkWithHref } from '@angular/router'
import { SunleonService } from '../../../sunleon/data-access/http/sunleon.service'
import { ToastrService } from 'ngx-toastr'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { combineLatestWith, firstValueFrom, startWith, Subject, takeUntil, tap } from 'rxjs'
import { CalepinageService } from '../../data-access/calepinage.service'
import { GeomapDomainService } from '../../domain/geomap.domain'
import { ControlPanelComponent } from '../control-panel/control-panel.component'
import { MeasureDisplayComponent } from '../measure-display/measure-display.component'
import { ProcessResultDto } from 'src/app/sunleon/data-access/http/dto/ProcessResultDto'
import { ParametresModulableComponent } from '../parametres-modulable/parametres-modulable.component'
import { ParametreTableauSaveDto } from 'src/app/parametre/data-access/http/dto/parametre-tableau-save-dto'
import { ParametreSpecifiqueSaveDto } from 'src/app/parametre/data-access/http/dto/parametre-specifique-save-dto'
import { ParametreDto } from 'src/app/parametre/data-access/http/dto/parametre-dto'
import { GoogleDriveDto } from '../../model/google-drive-dto'
import { GoogleDrivePickerService } from 'src/app/sunleon/data-access/http/google-drive-picker.service'
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component'
import { SimulationEnregistreComponent } from '../simulation-enregistre/simulation-enregistre.component'
import { PolygonDto } from '../../model/zone-measures'
import { ParametreSpecfiqueBddEnedisDto } from 'src/app/parametre/data-access/http/dto/parametre-specfique-bdd-enedis-dto'
import { SharepointService } from 'src/app/sunleon/data-access/http/sharepoint-service'

@Component({
  selector: 'app-form-parent',
  templateUrl: './form-parent.component.html',
  styleUrls: ['./form-parent.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    AsyncPipe,
    NgForOf,
    FormProjetComponent,
    FormModeValorisationComponent,
    FormRaccordementComponent,
    FormCapexGeneralisesComponent,
    FormCapexTypePoseComponent,
    ParametresModulableComponent,
    ParametresModulableComponent,
    FormZone1Component,
    FormZone2Component,
    FormZone3Component,
    FormZone4Component,
    FormZone5Component,
    FormZone6Component,
    FormsModule,
    ControlPanelComponent,
    MeasureDisplayComponent,
    RouterLinkWithHref,
    ReactiveFormsModule,
    SimulationEnregistreComponent
  ],
})
export class FormParentComponent implements AfterViewInit, OnDestroy {
  @Input()
  bNouvelleSimulation: boolean

  @Input()
  showSimulationEnreg: boolean

  @ViewChild('ngForm')
  ngForm: NgForm

  @ViewChild('contentSuccess')
  modalContentSucces: any

  formIsSubmitting: boolean = false
  formModalIsSubmitting: boolean = false

  ongletActif: OngletEnum
  ongletEnum: typeof OngletEnum
  parentForm: FormGroup

  status: string | undefined
  processIdEnregistrementSimulation: string | undefined
  processIdCreationCsv: string | undefined

  bSol: boolean = false
  bOmbriere: boolean = false
  bToiture: boolean = false

  bZone1Renseigne: boolean = false
  bZone2Renseigne: boolean = false
  bZone3Renseigne: boolean = false
  bZone4Renseigne: boolean = false
  bZone5Renseigne: boolean = false
  bZone6Renseigne: boolean = false
  visibleAdditionalZonesCount: number = 0

  apiMessageSuccess : string = '';

  urlDownloadSimu : string;
  csvPresentation : File;
  csvDevis : File;
  csvVE : File;

  private readonly geomapDomainService = inject(GeomapDomainService)
  private readonly calepinageService = inject(CalepinageService)
  private currentZoneHasBeanReset$ = this.geomapDomainService.currentZoneHasBeanReset$
  private unsubscribe$ = new Subject<void>()
  private parametresSimple = new Map<string, string>();
  private parametresTableau = new Map<string, ParametreTableauSaveDto>();
  private parametresSpécifique = new Map<string, ParametreSpecifiqueSaveDto>();

  get overloadedParametresSimple(): Map<string, string> {
    return this.parametresSimple
  }
  get overloadedParametresTableau(): Map<string, ParametreTableauSaveDto> {
    return this.parametresTableau
  }
  get overloadedParametresSpecifique(): Map<string, ParametreSpecifiqueSaveDto> {
    return this.parametresSpécifique
  }

  constructor(
    private simulationService: SunleonService,
    private sunLeonService: SunleonService,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private googleDrivePickerService: GoogleDrivePickerService,
    private sharepointUploadService: SharepointService
  ) {
    this.ongletActif = OngletEnum.Projet
    this.ongletEnum = OngletEnum
    this.parentForm = new FormGroup({})
  }

  ngAfterViewInit(): void {
    if (this.showSimulationEnreg){
      this.ongletActif = OngletEnum.SimulationEnregistre
    }
    this.sunLeonService.overloadableParametres$.subscribe(param => {
      if (param) {
        this.parametresSimple.set(param.code, param.value);
      }
    });

    this.sunLeonService.overloadableParametresTableau$.subscribe(param => {
      if (param) {
        this.parametresTableau.set(param.parametreDto.code, param.valeurs);
      }
    });

    this.sunLeonService.overloadableParametresSpécifique$.subscribe(param => {
      if (param) {
        this.parametresSpécifique.set(param.parametreDto.code, param.valeurs);
      }
    });

    const observableZone1 = this.parentForm.get('zone1').get('typePoseZone1').valueChanges.pipe(startWith(null))
    const observableZone2 = this.parentForm.get('zone2').get('typePoseZone2').valueChanges.pipe(startWith(null))
    const observableZone3 = this.parentForm.get('zone3').get('typePoseZone3').valueChanges.pipe(startWith(null))
    const observableZone4 = this.parentForm.get('zone4').get('typePoseZone4').valueChanges.pipe(startWith(null))
    const observableZone5 = this.parentForm.get('zone5').get('typePoseZone5').valueChanges.pipe(startWith(null))
    const observableZone6 = this.parentForm.get('zone6').get('typePoseZone6').valueChanges.pipe(startWith(null))

    observableZone1.pipe(combineLatestWith([observableZone2, observableZone3, observableZone4, observableZone5, observableZone6]), tap()).subscribe((values: string[]) => {
      if (values.find((value) => value === 'TOITURE')) {
        this.bToiture = true
      } else {
        this.bToiture = false
      }

      if (values.find((value) => value === 'SOL')) {
        this.bSol = true
      } else {
        this.bSol = false
      }

      if (values.find((value) => value === 'OMBRIERE')) {
        this.bOmbriere = true
      } else {
        this.bOmbriere = false
      }
      
      this.bZone1Renseigne = values[0] !== undefined && values[0] !== null
      this.bZone2Renseigne = values[1] !== undefined && values[1] !== null
      this.bZone3Renseigne = values[2] !== undefined && values[2] !== null
      this.bZone4Renseigne = values[3] !== undefined && values[3] !== null
      this.bZone5Renseigne = values[4] !== undefined && values[4] !== null
      this.bZone6Renseigne = values[5] !== undefined && values[5] !== null
      this.cdr.detectChanges();

    })

    this.currentZoneHasBeanReset$.pipe(takeUntil(this.unsubscribe$)).subscribe((activeZoneId) => {
      if (activeZoneId >= 0 && activeZoneId <= 6 && activeZoneId !== 3) {
        const listeZones: Record<number, string> = { 0: 'zone1', 1: 'zone2', 2: 'zone3', 4: 'zone4', 5: 'zone5', 6: 'zone6' }
        const zoneKey = listeZones[activeZoneId]
        const zone = this.parentForm.get(zoneKey) as FormGroup | null
        zone?.reset()

        if (zoneKey !== 'zone1') {
          Object.keys(zone?.controls ?? {}).forEach(controlName => {
            const control = zone?.get(controlName);
            control?.reset();
            control?.clearValidators();
            control?.updateValueAndValidity();
          });
        }
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe$.next()
  }

  addChildsFormGroup(formChild: FormGroup, controlName: string): void {
    this.parentForm.addControl(controlName, formChild)
    this.cdr.detectChanges()
  }

  saveSimulation(): void {
    const formValueModeValorisation = this.parentForm.get('modevalorisation')?.value
    const totalChosenPower = this.getTotalChosenPower()
    if (
      formValueModeValorisation?.modeValorisation === 'AC' &&
      totalChosenPower != null &&
      formValueModeValorisation?.puissanceSouscriteKVA != null &&
      Number(formValueModeValorisation.puissanceSouscriteKVA) < Number(totalChosenPower) / 1.2
    ) {
      this.toastr.error('En autoconsommation, la puissance souscrite doit etre superieure ou egale a la puissance estimative de la centrale / 1.2.')
      this.formIsSubmitting = false
      return
    }

    if (!this.parentForm.valid) {
      this.parentForm.markAllAsTouched()
      scrollToInvalidElement()
      this.formIsSubmitting = false
      return
    }

    this.formIsSubmitting = true
    const simulationSave = this.getSessionSaveFromForm()
    this.openDialogLivrable(simulationSave)
  }

  openDialogLivrable(simulationSave : SessionSaveDto): void {
    const formValueProjet = this.parentForm.get('projet').value
    const modalRef = this.modalService.open(ModalGenerationLivrableComponent, { size: 'lg' });
    modalRef.componentInstance.nomClient = formValueProjet.nomClient;
    modalRef.componentInstance.nomProjet = formValueProjet.nomProjet;
    modalRef.componentInstance.isParentForm = true;

    modalRef.result.then((formData : any) => {
      if (formData) {
        this.transformSession(formData, simulationSave)
      }
    });
  }

  transformSession(formData : any, simulationSave : SessionSaveDto) {
    this.simulationService.transformSession(simulationSave).subscribe({
      next: (data: ProcessResultDto) => {
        // Divisez la chaîne en utilisant le caractère "|"
        const elements: string[] = data.message.split('|')
        // Maintenant, elements[0] contient "Premier Élément" et elements[1] contient "Deuxième Élément"
        // Vous pouvez utiliser ces éléments comme vous le souhaitez
        this.processIdEnregistrementSimulation = elements[0]
        this.processIdCreationCsv = elements[1]
        this.monitorProcessStatusSession(this.processIdEnregistrementSimulation, this.processIdCreationCsv, formData, data.idSimulation)
      },
      error: () => {
        this.formIsSubmitting = false
        this.modalService.dismissAll()
      },
    })
  }

  monitorProcessStatusSession(processIdEnregistrementSimulation: string, processIdCreationCsv: string, formData: any, idSimulation : number) {
    const hasLivrable = formData.csvSlide || formData.csvDevis || formData.csvVE;
    this.simulationService.getProcessStatusSession(processIdEnregistrementSimulation).subscribe((result) => {
      this.status = result.status
      if (this.status === 'COMPLETED') {
        this.toastr.info(result.message)
        this.sunLeonService
          .checkSecondProcessStatus(processIdCreationCsv, processIdEnregistrementSimulation, idSimulation)
          .subscribe((result) => {
            this.status = result.status
            if (this.status === 'COMPLETED') {
              if(result.idSimulation != null) {
                this.getLivrables(result.idSimulation, formData).then(() => {
                    this.sendFilesToSharepoint(formData, result.idSimulation)
                    if (hasLivrable) {
                      this.simulationService.generateLivrable(idSimulation, formData.idFolder, formData.csvSlide, formData.csvDevis, formData.csvVE).subscribe({
                      next: (res: any) => {
                          const modalRef = this.modalService.open(ConfirmationModalComponent);
                          modalRef.componentInstance.titre = 'Simulation '+idSimulation+' terminé !';
                          modalRef.componentInstance.message = 'Souhaitez-vous ouvrir le dossier dans un nouvel onglet?';
                          modalRef.componentInstance.confirmation = '';
                          modalRef.result.then((confirmed : any) => {
                              if (confirmed) {
                                window.open(formData.urlFolder, '_blank');
                              }
                          });
                      },
                      error: (err) => {
                        console.error("Erreur HTTP :", err);
                        this.toastr.error(result.message)
                      }
                      });
                    }
                }) 
              }
              if (result.urlCsv != null) {
                saveAs(result.urlCsv, result.nomCsv)
                this.urlDownloadSimu = result.urlCsv;
                this.toastr.success(result.message)
                this.apiMessageSuccess = result.message;
                this.openModalSuccess();
                this.formIsSubmitting = false
              }

              this.processIdCreationCsv = undefined
            } else {
              if (this.status === 'FAILED') {
                if(result.idSimulation != null) {
                  this.getLivrables(result.idSimulation, formData).then(() => {
                    this.sendFilesToSharepoint(formData, result.idSimulation)
                    if (hasLivrable) {
                      this.simulationService.generateLivrable(idSimulation, formData.idFolder, formData.csvSlide, formData.csvDevis, formData.csvVE).subscribe({
                      next: (res: any) => {
                          const modalRef = this.modalService.open(ConfirmationModalComponent);
                          modalRef.componentInstance.titre = 'Simulation '+idSimulation+' terminé !';
                          modalRef.componentInstance.message = 'Souhaitez-vous ouvrir le dossier dans un nouvel onglet?';
                          modalRef.componentInstance.confirmation = '';
                          modalRef.result.then((confirmed : any) => {
                              if (confirmed) {
                                window.open(formData.urlFolder, '_blank');
                              }
                          });
                      },
                      error: (err) => {
                        console.error("Erreur HTTP :", err);
                        this.toastr.error(result.message)
                      }
                    });
                    }
                  })                  
                  this.formIsSubmitting = false
                  this.toastr.error(result.message)
                  this.processIdCreationCsv = undefined
                }
              } else {
                this.toastr.info(result.message)
              }
            }
          })
      } else {
        if (this.status === 'FAILED') {
          this.formIsSubmitting = false
          this.toastr.error(result.message)
          this.processIdEnregistrementSimulation = undefined
        } else {
          this.toastr.info(result.message)
        }
      }
    })
  }

  getSessionSaveFromForm() {
    const formValueProjet = this.parentForm.get('projet').value
    const formValueModeValorisation = this.parentForm.get('modevalorisation').value
    const formValueRaccordement = this.parentForm.get('raccordement').value
    const formValueCapexGeneralises = this.parentForm.get('capexgeneralises').value
    const formValueCapexTypePose = this.parentForm.get('capextypepose').value
    const formValueZone1 = this.parentForm.get('zone1').value
    const formValueZone2 = this.parentForm.get('zone2').value
    const formValueZone3 = this.parentForm.get('zone3').value
    const formValueZone4 = this.parentForm.get('zone4').value
    const formValueZone5 = this.parentForm.get('zone5').value
    const formValueZone6 = this.parentForm.get('zone6').value
    const zoneDto: SessionZoneSaveDto[] = []
    const communDto: SessionCommunSaveDto = {
      nomClient: formValueProjet.nomClient,
      nomProjet: formValueProjet.nomProjet,
      numMonday: formValueProjet.numMonday,
      latitude: formValueProjet.latitude,
      longitude: formValueProjet.longitude,
      departement: formValueProjet.departement,
      dureeContrat: formValueProjet.dureeContrat,
      aEnregistrer: formValueProjet.aEnregistrer,

      modeValorisation: formValueModeValorisation.modeValorisation,
      mecanismeReventeSurplus: formValueModeValorisation.mecanismeReventeSurplus,
      puissanceSouscriteKVA: formValueModeValorisation.puissanceSouscriteKVA,
      travauxDistanceVoirieVrd:
        formValueModeValorisation.travauxDistanceVoirieVrd === null
          ? 0
          : formValueModeValorisation.travauxDistanceVoirieVrd,
      prm: formValueModeValorisation.prm,
      ptrAC : formValueModeValorisation.ptrAC,
      tarifHch: formValueModeValorisation.tarifHch,
      tarifHph: formValueModeValorisation.tarifHph,
      tarifHpt: formValueModeValorisation.tarifHpt,
      tarifHpb: formValueModeValorisation.tarifHpb,
      tarifHcb: formValueModeValorisation.tarifHcb,
      dispositifNonInjection: formValueModeValorisation.dispositifNonInjection === true,
      dispoTGBT: formValueModeValorisation.dispoTGBT,
      automate: formValueModeValorisation.automate,
      puissanceCentraleEstimee: formValueRaccordement.puissanceCentraleEstimee,
      typeRaccordement: formValueRaccordement.typeRaccordement,
      nombreCompteur: formValueRaccordement.nombreCompteur,
      modeRaccordement: formValueRaccordement.typeRaccordement,
      nbCompteur: formValueRaccordement.nombreCompteur,
      compteursCoordinates: this.geomapDomainService.getCompteursCoordinatesSnapshot(),
      positionPosteTransfoCoordinates: formValueRaccordement.positionPosteTransfoCoordinates,
      distanceVoirieEnedis: formValueRaccordement.distanceVoirieEnedis,
      voirieEnedisCoordinates: this.geomapDomainService.getVoirieEnedisCoordinatesSnapshot(),
      trancheePriveeEnrobee: formValueRaccordement.trancheePriveeEnrobee,
      trancheePriveeTerrainNaturel: formValueRaccordement.trancheePriveeTerrainNaturel,
      trancheePriveeToiture: formValueRaccordement.trancheePriveeToiture,
      trancheeEnrobeeCoordinates: formValueRaccordement.trancheeEnrobeeCoordinates,
      trancheeTerrainNaturelCoordinates: formValueRaccordement.trancheeTerrainNaturelCoordinates,
      trancheeToitureCoordinates: formValueRaccordement.trancheeToitureCoordinates,
      trenchCoordinates: this.geomapDomainService.getTrenchCoordinatesSnapshot(),

      typeGammePanneau: formValueCapexGeneralises.typeGammePanneau,
      typeGammeOnduleur: formValueCapexGeneralises.typeGammeOnduleur,
      coffretDc: formValueCapexGeneralises.coffretDc,
      paratonnerre: formValueCapexGeneralises.paratonnerre,
      aerodrome: formValueCapexGeneralises.aerodrome,
      prixApportAffaireHtWc:
        formValueCapexGeneralises.prixApportAffaireHtWc === null ? 0 : formValueCapexGeneralises.prixApportAffaireHtWc,
      travauxDiversHT:
        formValueCapexGeneralises.travauxDiversHT === null ? 0 : formValueCapexGeneralises.travauxDiversHT,
      stationMeteo: formValueCapexGeneralises.stationMeteo,
      deposeCandelabre: formValueCapexTypePose.deposeCandelabre === null ? 0 : formValueCapexTypePose.deposeCandelabre,
      poseCandelabre: formValueCapexTypePose.poseCandelabre === null ? 0 : formValueCapexTypePose.poseCandelabre,
      eclairageSousOmbriere: formValueCapexTypePose.eclairageSousOmbriere,
      descenteEpAlu: formValueCapexTypePose.descenteEpAlu,
      nbAbattageArbres: formValueCapexTypePose.nbAbattageArbres === null ? 0 : formValueCapexTypePose.nbAbattageArbres,
      mlClotureSol: formValueCapexTypePose.mlClotureSol === null ? 0 : formValueCapexTypePose.mlClotureSol,
      nbPortailsSol: formValueCapexTypePose.nbPortailsSol === null ? 0 : formValueCapexTypePose.nbPortailsSol,
      mlGardeCorpsProvisoire: formValueCapexTypePose.mlGardeCorpsProvisoire === null ? 0 : formValueCapexTypePose.mlGardeCorpsProvisoire,
      mlGardeCorpsDefinitif: formValueCapexTypePose.mlGardeCorpsDefinitif === null ? 0 : formValueCapexTypePose.mlGardeCorpsDefinitif,
      mlLigneDeVie: formValueCapexTypePose.mlLigneDeVie === null ? 0 : formValueCapexTypePose.mlLigneDeVie,
      nbEchelleCrinoline: formValueCapexTypePose.nbEchelleCrinoline === null ? 0 : formValueCapexTypePose.nbEchelleCrinoline,
      modeDebug: false,
      forcerSoulteEtRenteInialeVT:false,
      lotPVMarcheTCE: formValueProjet.lotPVMarcheTCE
    }

    if (formValueZone1.typePoseZone1 !== null) {
      zoneDto.push({
        id: 1,
        typePose: formValueZone1.typePoseZone1,
        surface: formValueZone1.surfaceZone1,
        puissanceChoisie: formValueZone1.puissanceChoisieZone1,
        azimut: formValueZone1.azimutZone1,
        typeToiture: formValueZone1.typeToitureZone1 === '' ? null : formValueZone1.typeToitureZone1,
        orientation: formValueZone1.orientationTerrasseZone1 ?? null,
        pvReady: formValueZone1.pvReadyZone1,
        inclinaison: formValueZone1.inclinaisonZone1,
        typeVehiculeParking:
          formValueZone1.typeVehiculeParkingZone1 === '' ? null : formValueZone1.typeVehiculeParkingZone1,
        typePlaceParking: formValueZone1.typePlaceParkingZone1 === '' ? null : formValueZone1.typePlaceParkingZone1,
        polygons: formValueZone1.polygonsZone1,
        azimutCoordinates: formValueZone1.azimutCoordinateZone1,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(0)
      })
    }

    if (formValueZone2.typePoseZone2 !== null) {
      zoneDto.push({
        id: 2,
        typePose: formValueZone2.typePoseZone2,
        surface: formValueZone2.surfaceZone2,
        puissanceChoisie: formValueZone2.puissanceChoisieZone2,
        azimut: formValueZone2.azimutZone2,
        typeToiture: formValueZone2.typeToitureZone2 === '' ? null : formValueZone2.typeToitureZone2,
        orientation: formValueZone2.orientationTerrasseZone2 ?? null,
        pvReady: formValueZone2.pvReadyZone2,
        inclinaison: formValueZone2.inclinaisonZone2,
        typeVehiculeParking:
          formValueZone2.typeVehiculeParkingZone2 === '' ? null : formValueZone2.typeVehiculeParkingZone2,
        typePlaceParking: formValueZone2.typePlaceParkingZone2 === '' ? null : formValueZone2.typePlaceParkingZone2,
        polygons: formValueZone2.polygonsZone2,
        azimutCoordinates: formValueZone2.azimutCoordinateZone2,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(1)
      })
    }

    if (formValueZone3.typePoseZone3 !== null) {
      zoneDto.push({
        id: 3,
        typePose: formValueZone3.typePoseZone3,
        surface: formValueZone3.surfaceZone3,
        puissanceChoisie: formValueZone3.puissanceChoisieZone3,
        azimut: formValueZone3.azimutZone3,
        typeToiture: formValueZone3.typeToitureZone3 === '' ? null : formValueZone3.typeToitureZone3,
        orientation: formValueZone3.orientationTerrasseZone3 ?? null,
        pvReady: formValueZone3.pvReadyZone3,
        inclinaison: formValueZone3.inclinaisonZone3,
        typeVehiculeParking:
          formValueZone3.typeVehiculeParkingZone3 === '' ? null : formValueZone3.typeVehiculeParkingZone3,
        typePlaceParking: formValueZone3.typePlaceParkingZone3 === '' ? null : formValueZone3.typePlaceParkingZone3,
        polygons: formValueZone3.polygonsZone3,
        azimutCoordinates: formValueZone3.azimutCoordinateZone3,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(2)
      })
    }
    if (formValueZone4.typePoseZone4 !== null) {
      zoneDto.push({
        id: 4,
        typePose: formValueZone4.typePoseZone4,
        surface: formValueZone4.surfaceZone4,
        puissanceChoisie: formValueZone4.puissanceChoisieZone4,
        azimut: formValueZone4.azimutZone4,
        typeToiture: formValueZone4.typeToitureZone4 === '' ? null : formValueZone4.typeToitureZone4,
        orientation: formValueZone4.orientationTerrasseZone4 ?? null,
        pvReady: formValueZone4.pvReadyZone4,
        inclinaison: formValueZone4.inclinaisonZone4,
        typeVehiculeParking:
          formValueZone4.typeVehiculeParkingZone4 === '' ? null : formValueZone4.typeVehiculeParkingZone4,
        typePlaceParking: formValueZone4.typePlaceParkingZone4 === '' ? null : formValueZone4.typePlaceParkingZone4,
        polygons: formValueZone4.polygonsZone4,
        azimutCoordinates: formValueZone4.azimutCoordinateZone4,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(4)
      })
    }
    if (formValueZone5.typePoseZone5 !== null) {
      zoneDto.push({
        id: 5,
        typePose: formValueZone5.typePoseZone5,
        surface: formValueZone5.surfaceZone5,
        puissanceChoisie: formValueZone5.puissanceChoisieZone5,
        azimut: formValueZone5.azimutZone5,
        typeToiture: formValueZone5.typeToitureZone5 === '' ? null : formValueZone5.typeToitureZone5,
        orientation: formValueZone5.orientationTerrasseZone5 ?? null,
        pvReady: formValueZone5.pvReadyZone5,
        inclinaison: formValueZone5.inclinaisonZone5,
        typeVehiculeParking:
          formValueZone5.typeVehiculeParkingZone5 === '' ? null : formValueZone5.typeVehiculeParkingZone5,
        typePlaceParking: formValueZone5.typePlaceParkingZone5 === '' ? null : formValueZone5.typePlaceParkingZone5,
        polygons: formValueZone5.polygonsZone5,
        azimutCoordinates: formValueZone5.azimutCoordinateZone5,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(5)
      })
    }
    if (formValueZone6.typePoseZone6 !== null) {
      zoneDto.push({
        id: 6,
        typePose: formValueZone6.typePoseZone6,
        surface: formValueZone6.surfaceZone6,
        puissanceChoisie: formValueZone6.puissanceChoisieZone6,
        azimut: formValueZone6.azimutZone6,
        typeToiture: formValueZone6.typeToitureZone6 === '' ? null : formValueZone6.typeToitureZone6,
        orientation: formValueZone6.orientationTerrasseZone6 ?? null,
        pvReady: formValueZone6.pvReadyZone6,
        inclinaison: formValueZone6.inclinaisonZone6,
        typeVehiculeParking:
          formValueZone6.typeVehiculeParkingZone6 === '' ? null : formValueZone6.typeVehiculeParkingZone6,
        typePlaceParking: formValueZone6.typePlaceParkingZone6 === '' ? null : formValueZone6.typePlaceParkingZone6,
        polygons: formValueZone6.polygonsZone6,
        azimutCoordinates: formValueZone6.azimutCoordinateZone6,
        panneaux: this.geomapDomainService.getPanneauxSnapshot(6)
      })
    }

    return {
      commun: communDto,
      zones: zoneDto,  
      parametres: Object.fromEntries(this.parametresSimple),
      parametresTableau: Object.fromEntries(this.parametresTableau),
      parametresSpecifique: Object.fromEntries(this.parametresSpécifique)
    } as SessionSaveDto
  }

  onButtonProjetClick() {
    this.ongletActif = OngletEnum.Projet
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonModeValorisationClick() {
    this.ongletActif = OngletEnum.ModeValorisation
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonRaccordementClick() {
    this.ongletActif = OngletEnum.Raccordement
    this.geomapDomainService.openRaccordementTools()
  }

  onButtonOptionsCapexClick() {
    this.ongletActif = OngletEnum.OptionsCapex
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonCapexTypePoseClick() {
    this.ongletActif = OngletEnum.CapexTypePose
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonParametresModulablesClick() {
    this.ongletActif = OngletEnum.ParametresModulables
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonSimulationEnregistreClick() {
    this.ongletActif = OngletEnum.SimulationEnregistre
    this.geomapDomainService.disableTools()
    this.geomapDomainService.deselectionBarreOutils()
  }

  onButtonZone1Click() {
    this.ongletActif = OngletEnum.Zone1
    this.setZone(0)
  }
  onButtonZone2Click() {
    this.ongletActif = OngletEnum.Zone2
    this.setZone(1)
  }
  onButtonZone3Click() {
    this.ongletActif = OngletEnum.Zone3
    this.setZone(2)
  }
  onButtonZone4Click() {
    this.ongletActif = OngletEnum.Zone4
    this.setZone(4)
  }
  onButtonZone5Click() {
    this.ongletActif = OngletEnum.Zone5
    this.setZone(5)
  }
  onButtonZone6Click() {
    this.ongletActif = OngletEnum.Zone6
    this.setZone(6)
  }
  toggleAdditionalZones(): void {
    this.visibleAdditionalZonesCount = Math.min(3, this.visibleAdditionalZonesCount + 1)
  }

  /* OUTILS DESSINS */

  setZone(zoneIndex: number): void {
    this.geomapDomainService.setZone(zoneIndex)
    this.geomapDomainService.selectionBarreOutils()
    this.geomapDomainService.selectionDessinOutilsSeulementZone()
  }

  setAucunDessin(): void {
    this.geomapDomainService.deselectionDessinOutilsSeulementZone()
    this.geomapDomainService.hiddenCurrentZone()
  }

  openModalSuccess() {
    this.modalService
      .open(this.modalContentSucces, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false })
      .result.then(
      () => {
        this.apiMessageSuccess = '';
        this.formModalIsSubmitting = false
      },
      () => {
        this.apiMessageSuccess = '';
        this.formModalIsSubmitting = false
      }
    )
  }

  async getLivrables(idSimulation: number, formData: any) {
    const calls = [];

    if (formData.csvSlide) {
      calls.push({
        obs: this.sunLeonService.getLivrableAsCsv(idSimulation),
        filename: "Presentation_" + idSimulation + ".csv",
        type: "csvPresentation",
      });
    }
    if (formData.csvDevis) {
      calls.push({
        obs: this.sunLeonService.getGenerateurDevisAsCsv(idSimulation),
        filename: "Devis_" + idSimulation + ".csv",
        type: "csvDevis",
      });
    }
    if (formData.csvVE) {
      calls.push({
        obs: this.sunLeonService.getGenerateurValidationEngagementAsCsv(idSimulation),
        filename: "Validation_Engagement_" + idSimulation + ".csv",
        type: "csvVE",
      });
    }

    for (const call of calls) {
      const content = await firstValueFrom(call.obs);
      if (content) {
        const contentDisposition = content.headers.get('Content-Disposition');

        let filename = call.filename;
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1];
          }
        }

        const file = new Blob([content.body], { type: 'text/csv;charset=ISO-8859-1' });
        const url = window.URL.createObjectURL(file);

        const fileObj = new File([file], filename);

        if (call.type === "csvPresentation") {
          this.csvPresentation = fileObj;
        } else if (call.type === "csvDevis") {
          this.csvDevis = fileObj;
        } else if (call.type === "csvVE") {
          this.csvVE = fileObj;
        }

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();

        window.URL.revokeObjectURL(url);
      }
    }
  }

  sendFilesToGoogleDrive(formData: any, idSimulation: number) {
    if (formData.idFolder) {
      const screenshotName = "capture_" + idSimulation + ".png";
      const newScreenshot: File | null = formData.screenshot
        ? new File([formData.screenshot], screenshotName)
        : null;

      const googleDriveDto: GoogleDriveDto = {
        folderId: formData.idFolder,
        screenshot: newScreenshot,
        urlDownloadSimu: this.urlDownloadSimu,
        simuFileName: 'SUNLEON_' + idSimulation + ".csv",
        csvPresentation: formData.csvSlide ? this.csvPresentation : null,
        csvDevis: formData.csvDevis ? this.csvDevis : null,
        csvVE: formData.csvVE ? this.csvVE : null,
      };

      this.googleDrivePickerService.saveToFolder(googleDriveDto).subscribe({
        next: () => {},
        error: (err: any) => {
          console.log("Erreur lors de l'envoi : " + err.message);
        },
      });
    } else {
      console.log("Pas de dossier sélectionné");
    }
  }

  sendFilesToSharepoint(formData: any, idSimulation: number) {
    if (!formData?.driveId || !formData?.idFolder) {
      console.warn("Données SharePoint incomplètes");
      this.toastr.warning("Aucun dossier SharePoint sélectionné");
      return;
    }

    const screenshotName = `capture_${idSimulation}.png`;
    const newScreenshot: File | null = formData.screenshot
      ? new File([formData.screenshot], screenshotName, { type: 'image/png' })
      : null;

    const payload = {
      driveId: formData.driveId,
      folderItemId: formData.idFolder,
      screenshot: newScreenshot,
      urlDownloadSimu: this.urlDownloadSimu,
      simuFileName: 'SUNLEON_' + idSimulation + ".csv",
      csvPresentation: formData.csvSlide ? this.csvPresentation : null,
      csvDevis: formData.csvDevis ? this.csvDevis : null,
      csvVE: formData.csvVE ? this.csvVE : null,
    };

    this.sharepointUploadService.upload(payload).subscribe({
      next: () => {
        console.log("Fichiers envoyés avec succès vers SharePoint");
        this.toastr.success("Fichiers envoyés avec succès vers SharePoint");
      },
      error: (err) => {
        console.error("Erreur upload SharePoint:", err);
        this.toastr.error("Échec de l'envoi des fichiers vers SharePoint");
      }
    });
  }

  onScenarioSelected(scenario: SessionSaveDto): void {
    this.ngForm.resetForm();
    this.parentForm.reset();

    if (scenario.zones) {
      const zoneForms = ['zone1', 'zone2', 'zone3', 'zone4', 'zone5', 'zone6'];
      scenario.zones.forEach((zone: SessionZoneSaveDto) => {
        const domainZoneIndex = this.getDomainZoneIndex(zone.id);
        const selectedTypePoseIndex = zone.id - 1
        if (zone.id >= 1 && zone.id <= zoneForms.length) {
          const zoneForm = this.parentForm.get(zoneForms[zone.id - 1]);
          if (zoneForm) {
            zoneForm.patchValue({
              [`typePoseZone${zone.id}`]: zone.typePose,
              [`surfaceZone${zone.id}`]: zone.surface,
              [`puissanceChoisieZone${zone.id}`]: zone.puissanceChoisie,
              [`azimutZone${zone.id}`]: zone.azimut,
              [`typeToitureZone${zone.id}`]: zone.typeToiture,
              [`orientationTerrasseZone${zone.id}`]: zone.orientation ?? 'SUD',
              [`pvReadyZone${zone.id}`]: zone.pvReady,
              [`inclinaisonZone${zone.id}`]: zone.inclinaison,
              [`typeVehiculeParkingZone${zone.id}`]: zone.typeVehiculeParking,
              [`typePlaceParkingZone${zone.id}`]: zone.typePlaceParking,
              [`polygonsZone${zone.id}`]: zone.polygons,
              [`azimutCoordinateZone${zone.id}`]: zone.azimutCoordinates,
            });
            this.updateZoneValidators(zoneForm as FormGroup, zone.id);
            this.geomapDomainService.selectTypePoseOutils(selectedTypePoseIndex)
            this.geomapDomainService.selectionBarreOutils()
            this.geomapDomainService.selectionDessinOutilsSeulementZone()

            this.geomapDomainService.drawZoneShapes(domainZoneIndex, zone);
            // Les panneaux restaurés ne doivent pas être écrasés par une régénération auto :
            // le service adoptera l'état restauré au prochain déclenchement.
            this.calepinageService.notifyZoneRestored(domainZoneIndex);

            if (zone.id === 1) this.bZone1Renseigne = true;
            if (zone.id === 2) this.bZone2Renseigne = true;
            if (zone.id === 3) this.bZone3Renseigne = true;
            if (zone.id === 4) this.bZone4Renseigne = true;
            if (zone.id === 5) this.bZone5Renseigne = true;
            if (zone.id === 6) this.bZone6Renseigne = true;
          }
        }
      });
      this.parentForm.updateValueAndValidity();
      zoneForms.forEach((formName, index) => {
        if (!scenario.zones.some(z => z.id === index + 1)) {
          const zoneForm = this.parentForm.get(formName);
          if (zoneForm) {
            zoneForm.reset();
            const domainZoneIndex = this.getDomainZoneIndex(index + 1);
            if (domainZoneIndex >= 0) {
              this.geomapDomainService.setZone(domainZoneIndex);
            }
            this.geomapDomainService.resetCurrentZone();
            if (index === 1) this.bZone2Renseigne = false;
            if (index === 2) this.bZone3Renseigne = false;
            if (index === 3) this.bZone4Renseigne = false;
            if (index === 4) this.bZone5Renseigne = false;
            if (index === 5) this.bZone6Renseigne = false;
          }
        }
      });
    }

    if (scenario.commun) {
      const projetForm = this.parentForm.get('projet');
      if (projetForm) {
        projetForm.patchValue({
          nomClient: scenario.commun.nomClient,
          nomProjet: scenario.commun.nomProjet,
          numMonday: scenario.commun.numMonday,
          latitude: scenario.commun.latitude,
          longitude: scenario.commun.longitude,
          departement: scenario.commun.departement,
          dureeContrat: scenario.commun.dureeContrat,
          lotPVMarcheTCE: scenario.commun.lotPVMarcheTCE,
          aEnregistrer: true,
        });
      }
      const modeValorisationForm = this.parentForm.get('modevalorisation');
      if (modeValorisationForm) {
        modeValorisationForm.patchValue({
          modeValorisation: scenario.commun.modeValorisation,
          mecanismeReventeSurplus: scenario.commun.mecanismeReventeSurplus,
          puissanceSouscriteKVA: scenario.commun.puissanceSouscriteKVA,
          travauxDistanceVoirieVrd: scenario.commun.travauxDistanceVoirieVrd,
          prm: scenario.commun.prm,
          ptrAC: scenario.commun.ptrAC,
          tarifHch: scenario.commun.tarifHch,
          tarifHph: scenario.commun.tarifHph,
          tarifHpt: scenario.commun.tarifHpt,
          tarifHpb: scenario.commun.tarifHpb,
          tarifHcb: scenario.commun.tarifHcb,
          dispoTGBT: scenario.commun.dispoTGBT,
          automate: scenario.commun.automate,
        });

        modeValorisationForm.get('modeValorisation').updateValueAndValidity();
        modeValorisationForm.get('modeValorisation').markAsDirty();
        this.geomapDomainService.setSelectedRaccordementType(((scenario.commun.modeRaccordement || scenario.commun.typeRaccordement) as 'BT' | 'HT') ?? 'BT');
        this.geomapDomainService.drawRaccordementPublic({
          trenchCoordinates: scenario.commun.trenchCoordinates || [],
          distanceVoirieEnedis: scenario.commun.distanceVoirieEnedis || 0,
          voirieEnedisCoordinates: scenario.commun.voirieEnedisCoordinates || [],
          totalTrancheeEnrobee: scenario.commun.trancheePriveeEnrobee || 0,
          trancheeEnrobeeCoordinates: scenario.commun.trancheeEnrobeeCoordinates || [],
          totalTrancheeTerrainNaturel: scenario.commun.trancheePriveeTerrainNaturel || 0,
          trancheeTerrainNaturelCoordinates: scenario.commun.trancheeTerrainNaturelCoordinates || [],
          totalTrancheeToiture: scenario.commun.trancheePriveeToiture || 0,
          trancheeToitureCoordinates: scenario.commun.trancheeToitureCoordinates || [],
          compteursCoordinates: scenario.commun.compteursCoordinates || [],
          positionPosteTransfoCoordinates: scenario.commun.positionPosteTransfoCoordinates || null,
        });
      }
      const raccordementForm = this.parentForm.get('raccordement');
      if (raccordementForm) {
        raccordementForm.patchValue({
          puissanceCentraleEstimee: scenario.commun.puissanceCentraleEstimee,
          typeRaccordement: scenario.commun.modeRaccordement ?? scenario.commun.typeRaccordement ?? 'BT',
          nombreCompteur: scenario.commun.nbCompteur ?? scenario.commun.nombreCompteur,
          positionPosteTransfoCoordinates: scenario.commun.positionPosteTransfoCoordinates,
          distanceVoirieEnedis: scenario.commun.distanceVoirieEnedis,
          trancheePriveeEnrobee: scenario.commun.trancheePriveeEnrobee,
          trancheePriveeTerrainNaturel: scenario.commun.trancheePriveeTerrainNaturel,
          trancheePriveeToiture: scenario.commun.trancheePriveeToiture,
          trancheeEnrobeeCoordinates: scenario.commun.trancheeEnrobeeCoordinates,
          trancheeTerrainNaturelCoordinates: scenario.commun.trancheeTerrainNaturelCoordinates,
          trancheeToitureCoordinates: scenario.commun.trancheeToitureCoordinates,
        });
      }

      const capexGeneralisesForm = this.parentForm.get('capexgeneralises');
      if (capexGeneralisesForm) {
        capexGeneralisesForm.patchValue({
          typeGammePanneau: scenario.commun.typeGammePanneau,
          typeGammeOnduleur: scenario.commun.typeGammeOnduleur,
          coffretDc: scenario.commun.coffretDc,
          paratonnerre: scenario.commun.paratonnerre,
          aerodrome: scenario.commun.aerodrome,
          prixApportAffaireHtWc: scenario.commun.prixApportAffaireHtWc,
          travauxDiversHT: scenario.commun.travauxDiversHT,
          stationMeteo: scenario.commun.stationMeteo,
        });
      }

      const capexTypePoseForm = this.parentForm.get('capextypepose');
      if (capexTypePoseForm) {
        capexTypePoseForm.patchValue({
          deposeCandelabre: scenario.commun.deposeCandelabre,
          poseCandelabre: scenario.commun.poseCandelabre,
          eclairageSousOmbriere: scenario.commun.eclairageSousOmbriere,
          descenteEpAlu: scenario.commun.descenteEpAlu,
          nbAbattageArbres: scenario.commun.nbAbattageArbres,
          mlClotureSol: scenario.commun.mlClotureSol,
          nbPortailsSol: scenario.commun.nbPortailsSol,
          mlGardeCorpsProvisoire: scenario.commun.mlGardeCorpsProvisoire,
          mlGardeCorpsDefinitif: scenario.commun.mlGardeCorpsDefinitif,
          mlLigneDeVie: scenario.commun.mlLigneDeVie,
          nbEchelleCrinoline: scenario.commun.nbEchelleCrinoline,
        });
      }
    }

    this.bToiture = scenario.zones.some(z => z.typePose === 'TOITURE');
    this.bSol = scenario.zones.some(z => z.typePose === 'SOL');
    this.bOmbriere = scenario.zones.some(z => z.typePose === 'OMBRIERE');
    this.ngForm.control.markAllAsTouched();

    this.cdr.detectChanges();
    
    this.ongletActif = OngletEnum.Projet;
    if (scenario.parametres) {
        for (const [code, value] of Object.entries(scenario.parametres)) {
          this.sunLeonService.saveOverloadableParametres(code, value);
        }
      }
      if (scenario.parametresTableau) {
        for (const [code, dto] of Object.entries(scenario.parametresTableau)) {
          this.sunLeonService.saveOverloadableParametresTableau(dto.parametreDto, dto);
        }
      }
      if (scenario.parametresSpecifique) {
        for (const [code, dto] of Object.entries(scenario.parametresSpecifique)) {
          const specifiqueDto: ParametreSpecfiqueBddEnedisDto = {
            parametreDto: dto.parametreDto,
            lignes: dto.datas,
          };
          this.sunLeonService.saveOverloadableParametresSpécifique(dto.parametreDto, specifiqueDto);
        }
      }
      this.cdr.detectChanges();
  }

  private updateZoneValidators(zoneForm: FormGroup, zoneId: number): void {
    const typePose = zoneForm.get(`typePoseZone${zoneId}`)?.value as string | null;
    const puissanceChoisie = zoneForm.get(`puissanceChoisieZone${zoneId}`)?.value;
    const hasPower = puissanceChoisie !== null && puissanceChoisie !== undefined && puissanceChoisie !== '';

    const surface = zoneForm.get(`surfaceZone${zoneId}`);
    const azimut = zoneForm.get(`azimutZone${zoneId}`);
    const typeToiture = zoneForm.get(`typeToitureZone${zoneId}`);
    const pvReady = zoneForm.get(`pvReadyZone${zoneId}`);
    const inclinaison = zoneForm.get(`inclinaisonZone${zoneId}`);
    const typeVehicule = zoneForm.get(`typeVehiculeParkingZone${zoneId}`);
    const typePlace = zoneForm.get(`typePlaceParkingZone${zoneId}`);

    surface?.setValidators(null);
    azimut?.setValidators(null);
    typeToiture?.setValidators(null);
    pvReady?.setValidators(null);
    inclinaison?.setValidators(null);
    typeVehicule?.setValidators(null);
    typePlace?.setValidators(null);

    if (typePose) {
      surface?.setValidators(hasPower ? [Validators.pattern('^\\d+(\\.\\d{1,2})?$')] : [Validators.required, Validators.pattern('^\\d+(\\.\\d{1,2})?$')]);
      azimut?.setValidators(hasPower ? [Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')] : [Validators.required, Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')]);

      if (typePose === 'TOITURE') {
        typeToiture?.setValidators([Validators.required]);
        pvReady?.setValidators([Validators.required]);
        inclinaison?.setValidators([Validators.required, Validators.pattern('^\\d+$')]);
        typeVehicule?.setValidators(null); 
        typePlace?.setValidators(null);

        const typeToitureValue = typeToiture?.value;
        if (typeToitureValue === 'BETON' || typeToitureValue === 'TAN_ETANCHE') {
          azimut?.setValidators(hasPower ? [Validators.pattern('^-?([0-8][0-9]|9[0])$')] : [Validators.required, Validators.pattern('^-?([0-8][0-9]|9[0])$')]);
        }
      } else if (typePose === 'OMBRIERE') {
        typeVehicule?.setValidators([Validators.required]);
        typePlace?.setValidators(null); 
        typeToiture?.setValidators(null);
        pvReady?.setValidators(null);
        inclinaison?.setValidators(null);
      } else if (typePose === 'SOL') {
        typeToiture?.setValidators(null);
        pvReady?.setValidators(null);
        inclinaison?.setValidators(null);
        typeVehicule?.setValidators(null);
        typePlace?.setValidators(null);
      }
    } else {
      surface?.setValidators([Validators.pattern('^\\d+(\\.\\d{1,2})?$')]);
      azimut?.setValidators([Validators.pattern('^-?(180|\\d{1,2}|1[0-7]\\d)$')]);
    }

    surface?.updateValueAndValidity();
    azimut?.updateValueAndValidity();
    typeToiture?.updateValueAndValidity();
    pvReady?.updateValueAndValidity();
    inclinaison?.updateValueAndValidity();
    typeVehicule?.updateValueAndValidity();
    typePlace?.updateValueAndValidity();
  }

  private getTotalChosenPower(): number | null {
    const raccordementPower = this.parentForm.get('raccordement')?.get('puissanceCentraleEstimee')?.value
    if (raccordementPower != null && raccordementPower !== '') {
      return Number(raccordementPower)
    }

    const total = ['zone1', 'zone2', 'zone3', 'zone4', 'zone5', 'zone6'].reduce((acc, zoneKey, index) => {
        const value = this.parentForm.get(zoneKey)?.get(`puissanceChoisieZone${index + 1}`)?.value
        return acc + Number(value ?? 0)
      }, 0)

    return total > 0 ? total : null
  }

  private getDomainZoneIndex(zoneId: number): number {
    if (zoneId <= 3) {
      return zoneId - 1
    }
    return zoneId
  }
}
